module.exports = __webpack_public_path__ + "static/media/logoVizi.d5143a76.svg";